import * as yup from 'yup';

export const buyersCreateStep3Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    acceptedMaterials: yup.array().test({
      message: t('buyers.create.step3.materialsRequired'),
      test: arr => !!arr && arr.length > 0,
    }),
  });
